import {ShapeCommand} from '../commands.template';

export class ResourceDetachCommand extends ShapeCommand {
  protected services: any;
  private resource: any;
  private position: any;
  private activityMxKey: number;

  constructor(data) {
    super(data);
    this.resource = data.resource;
    this.activityMxKey = Number(data.activityMxKey);
    this.position = data.position;
  }

  public execute() {
    super.execute();
    const cell = this.services.graphHelperSvc
      .allActivities()
      .find(c => Number(c.id) === Number(this.activityMxKey));

    return this.services.resourceSvc.remove({
      resource: this.resource,
      cells: cell
    });
  }

  public reverse() {
    super.reverse();
    const cell = this.services.graphHelperSvc
      .allActivities()
      .find(c => Number(c.id) === Number(this.activityMxKey));

    return this.services.resourceSvc.add({
      resource: this.resource,
      cells: cell,
      position: this.position
    });
  }
}
